import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { Upload, message, Image } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import cloudIcon from 'utils/icon/icon_cloud-upload-image-black.svg';
import uploadIcon from 'utils/icon/icon_upload-image-black.svg';
import plusButtonIcon from 'utils/icon/icon_plus-blue.svg';
import PrimaryButton from 'components/button/PrimaryButton';
import { useTranslation } from 'react-i18next';
import { minicutApi } from 'apis/resource/minicutApis';
import { IMinicut } from 'utils/types/resourceTypes';
import { liveBackgroundApi } from 'apis/resource/liveBackgroundApis';
import { liveObjApi } from 'apis/resource/liveObjectApis';
import { liveIllustApi } from 'apis/resource/liveIllustApis';
import { Trash } from 'iconsax-react';

/**
 * * 오토메 - 작품 정보 수정
 */

interface IProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  type: string;
  isPublic?: boolean | undefined;
}

const UploadImage: React.FC<IProps> = ({
  data,
  setData,
  type,
  isPublic = undefined,
}) => {
  const [image, setImage] = useState<string | null>(null);
  useEffect(() => {
    if (data) {
      setImage(data?.thumbnail_url);
    }
  }, [data]);

  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState<boolean>(false);
  const handleMessage = (type, content) => {
    messageApi.open({
      type,
      content,
    });
  };
  const uploadAvatar = async (options) => {
    const { file, onSuccess, onError } = options;
    const isPNG = file.type === 'image/png';
    const isJPG = file.type === 'image/jpeg';

    if (isPNG || isJPG) {
      if (file.size > 4000000) {
        messageApi.error('Upload failed. Max size for files is 4 MB.');
      } else {
        if (data) {
          try {
            setLoading(true);
            const url =
              type === 'live_bg'
                ? liveBackgroundApi.liveBackgroundThumnailUpdate
                : type === 'live_object'
                ? liveObjApi.liveObjectThumnailUpdate
                : liveIllustApi.liveIllustThumnailUpdate;
            const res = await url(
              data.project_id.toString(),
              data.id.toString(),
              file,
            );

            const cloneData = JSON.parse(JSON.stringify(data));
            cloneData['thumbnail_key'] = res.thumbnail_key;
            cloneData['thumbnail_url'] = res.thumbnail_url;
            setData(cloneData);
            onSuccess('ok');
            handleMessage('success', 'Upload success');
            setLoading(false);
          } catch (err) {
            console.log('Error', err);
            handleMessage('error', `${file.name} upload failed`);
            onError(err);
            setLoading(false);
          }
        }
      }
    } else {
      handleMessage('error', `${file.name} is not a png file`);
    }
  };
  const props = {
    name: 'file',
    action: '',
    showUploadList: false,
    async onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log('uploading ===>', info.file, info.fileList);
      }
      if (info.file.status === 'done') {
      } else if (info.file.status === 'error') {
        console.log('failed ===>', info.file);
      }
    },
  };

  const handleRemoveImage = () => {
    setImage(null);
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData['thumbnail_key'] = null;
    cloneData['thumbnail_url'] = null;
    setData(cloneData);
  };

  return (
    <>
      <UploadWrapper isPublic={isPublic} type={type}>
        <UploadContentWrapper>
          <div>
            {loading ? (
              <div className='flex-wrap icon'>
                <LoadingOutlined style={{ fontSize: '50px' }} />
              </div>
            ) : image ? (
              <Image src={image} alt={`thumbnail`} className='icon' />
            ) : (
              <></>
            )}
          </div>
        </UploadContentWrapper>
        {!loading && (
          <div className='uploadTotalWrap'>
            <Upload {...props} maxCount={1} customRequest={uploadAvatar}>
              {image ? (
                <div style={{ marginLeft: 24 }}>
                  <PrimaryButton
                    text={t('buttons.replaceImage')}
                    height='40px'
                    width='fit-content'
                    bgColor='#ffffff'
                    textColor={theme.colors.dark_400}
                    fontWeight={theme.fontWeights.medium}
                    fontSize={theme.fontSizes.normal}
                    border={`1px solid ${theme.colors.gray_6}`}
                    rounded='6px'
                    hoverBgColor={theme.colors.gray_6}
                    activeBgColor={theme.colors.gray_6}
                    selectedBgColor={theme.colors.gray_6}
                    loading={loading}
                    LeftPlaceHolder={<img src={uploadIcon} alt='upload' />}
                  />
                  <p className='turText'>{t('updateStory.form.required')}</p>
                </div>
              ) : (
                <>
                  <div className='emptyImage'>
                    <img src={cloudIcon} alt='upload cloud' />
                    <p className='emptyImageText'>
                      {t('updateStory.form.placeholder')}
                    </p>
                    <img src={plusButtonIcon} alt='plus icon' />
                  </div>
                  <p className='turText'>{t('updateStory.form.required')}</p>
                </>
              )}
            </Upload>
            {image && (
              <PrimaryButton
                text={t('buttons.remove')}
                height='40px'
                width='fit-content'
                bgColor='#ffffff'
                textColor={theme.colors.dark_400}
                fontWeight={theme.fontWeights.medium}
                fontSize={theme.fontSizes.normal}
                border={`1px solid ${theme.colors.gray_6}`}
                rounded='6px'
                hoverBgColor={theme.colors.gray_6}
                activeBgColor={theme.colors.gray_6}
                selectedBgColor={theme.colors.gray_6}
                loading={loading}
                onClick={handleRemoveImage}
                LeftPlaceHolder={<Trash size='24' />}
              />
            )}
          </div>
        )}
        {!isPublic && <div className='disabled'></div>}
      </UploadWrapper>
      {contextHolder}
    </>
  );
};

export default UploadImage;

const UploadContentWrapper = styled.div`
  .upload {
    border: 1px solid ${theme.colors.gray_7};
    border-style: dotted;
  }
  .flex-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .icon {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

const UploadWrapper = styled.div<{ isPublic; type }>`
  position: relative;
  display: flex;
  .emptyImage {
    border: 1px solid ${theme.colors.dark_100};
    border-radius: 4px;
    border-style: dotted;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    & > * + * {
      margin-top: 10px;
    }
    cursor: pointer;
  }
  .turText {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }
  .emptyImageText {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
  .uploadTotalWrap {
    display: flex;
    & > * + * {
      margin-left: 8px;
    }
  }
  & > * + * {
    /* margin-left: 24px; */
    /* column-gap: 24px; */
  }
  .disabled {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.548);
  }
`;
